<div *ngIf="isExtraSettingsOn">
    <aumico-notes-input-options
        class="input-options"
        [options]="componentOptions"
        [languages]="languages"
        [language]="language"
        [addNumbering]="addNumbering"
        (onFormValueChange)="onFormChange($event)"
        (onFormStatusChange)="onFormStatusChange($event)"
        (onOpenReferenceDialog)="openReferenceDialog()"
        (onAddNumberToggleEmit)="onAddNumberToggleChange($event)"
    ></aumico-notes-input-options>
</div>

<form [formGroup]="form">
    <div class="notes-table" [ngClass]="{ aumPreview: viewMode <= 1, aumPrint: viewMode <= 0 }">
        <div class="notes-header notes-table-row">
            <div class="notes-cell notes-header-cell aumDescription">
                <span>{{ title }}</span>
            </div>
            <div class="notes-cell notes-header-cell aumHighlight">
                <span *ngIf="dataType !== 'CURRENCY'">{{ currentYearDate | dateLocale }}</span>
                <span *ngIf="dataType === 'CURRENCY'">{{ currentYearDate | dateLocale }} in {{ currency }}</span>
            </div>
            <div *ngIf="compareYears" class="notes-cell notes-header-cell">
                <span *ngIf="dataType !== 'CURRENCY'">{{ previousYearDate | dateLocale }}</span>
                <span *ngIf="dataType === 'CURRENCY'">{{ previousYearDate | dateLocale }} in {{ currency }}</span>
            </div>
        </div>
        <div class="notes-content notes-table-row">
            <ng-container *ngIf="viewMode >= 2">
                <!-- Edit Mode -->

                <div class="notes-cell aumDescription">
                    <span>{{ text[language] }}</span>
                </div>
                <div
                    class="notes-cell"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            ((dataType === 'TEXT' && form.controls['currentYearValue']?.value?.trim() === '') ||
                                (dataType === 'TEXT' && form.controls['currentYearValue']?.value?.trim() === '-') ||
                                (dataType === 'TEXT' && form.controls['currentYearValue']?.value === '0') ||
                                form.controls['currentYearValue']?.value === 0 ||
                                form.controls['currentYearValue']?.value === '-' ||
                                form.controls['currentYearValue']?.value === '' ||
                                form.controls['currentYearValue']?.value == null)
                    }"
                >
                    <aum-input
                        *ngIf="dataType === 'TEXT'"
                        [aumFormControl]="form.controls['currentYearValue']"
                        [placeholder]="'text'"
                    >
                    </aum-input>
                    <aumico-number-input
                        *ngIf="dataType === 'NUMBER' || dataType === 'CURRENCY'"
                        [control]="form.controls['currentYearValue']"
                        [placeholder]="0"
                        [decimalPlaces]="numberOfDecimalPlaces"
                    >
                    </aumico-number-input>
                </div>
                <div
                    *ngIf="compareYears"
                    class="notes-cell"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            ((dataType === 'TEXT' && form.controls['previousYearValue']?.value?.trim() === '') ||
                                (dataType === 'TEXT' && form.controls['previousYearValue']?.value?.trim() === '-') ||
                                (dataType === 'TEXT' && form.controls['previousYearValue']?.value === '0') ||
                                form.controls['previousYearValue']?.value === 0 ||
                                form.controls['previousYearValue']?.value === '-' ||
                                form.controls['previousYearValue']?.value === '' ||
                                form.controls['previousYearValue']?.value == null)
                    }"
                >
                    <!-- Replace with Input Value -->
                    <aum-input
                        *ngIf="dataType === 'TEXT'"
                        [aumFormControl]="form.controls['previousYearValue']"
                        [placeholder]="'text'"
                    >
                    </aum-input>
                    <aumico-number-input
                        *ngIf="dataType === 'NUMBER' || dataType === 'CURRENCY'"
                        [control]="form.controls['previousYearValue']"
                        [placeholder]="0"
                        [decimalPlaces]="numberOfDecimalPlaces"
                    >
                    </aumico-number-input>
                </div>
            </ng-container>
            <ng-container *ngIf="viewMode <= 1">
                <!-- Preview/Print Mode -->
                <div
                    class="notes-cell aumDescription"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (text[language]?.trim() === '' ||
                                text[language] === '0' ||
                                text[language] == null ||
                                text[language]?.trim() === '-')
                    }"
                >
                    <span>{{ text[language] }}</span>
                </div>
                <div
                    class="notes-cell aumHighlight"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            ((dataType === 'TEXT' && form.controls['currentYearValue']?.value?.trim() === '') ||
                                (dataType === 'TEXT' && form.controls['currentYearValue']?.value?.trim() === '-') ||
                                (dataType === 'TEXT' && form.controls['currentYearValue']?.value === '0') ||
                                form.controls['currentYearValue']?.value === 0 ||
                                form.controls['currentYearValue']?.value === '-' ||
                                form.controls['currentYearValue']?.value === '' ||
                                form.controls['currentYearValue']?.value == null)
                    }"
                >
                    <span>{{ form.controls['currentYearValue'].value }}</span>
                </div>
                <div
                    *ngIf="compareYears"
                    class="notes-cell"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            ((dataType === 'TEXT' && form.controls['previousYearValue']?.value?.trim() === '') ||
                                (dataType === 'TEXT' && form.controls['previousYearValue']?.value?.trim() === '-') ||
                                (dataType === 'TEXT' && form.controls['previousYearValue']?.value === '0') ||
                                form.controls['previousYearValue']?.value === 0 ||
                                form.controls['previousYearValue']?.value === '-' ||
                                form.controls['previousYearValue']?.value === '' ||
                                form.controls['previousYearValue']?.value == null)
                    }"
                >
                    <span>{{ form.controls['previousYearValue'].value }}</span>
                </div>
            </ng-container>
        </div>
    </div>
</form>
